import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { ClaimsNeedHelpComponent } from '../claims-need-help/claims-need-help.component';
import { UploadDocumentsSidebarComponent } from '../upload-documents-sidebar/upload-documents-sidebar.component';
import { CliamsNavComponent } from '../cliams-nav/cliams-nav.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Params , RouterModule } from '@angular/router';
import { ClaimsService } from '../../../../../_services/_claims/claims.service';
import { Capacitor } from '@capacitor/core';
import { DocumentsDataService } from '../../../../../_services/data-services/documents-data.service';
import { PolicyDetailsService } from '../../../../../_services/my-insurance/policy-details.service';
import { ClaimsDataService } from '../../../../../_services/_claims/claims-data.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { UrlValidationService } from '@services/document/url-validation.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, CliamsNavComponent, UploadDocumentsSidebarComponent, ClaimsNeedHelpComponent, MapfreButtonComponent],
  selector: 'app-claim-documents',
  templateUrl: './claim-documents.component.html',
  styleUrls: ['./claim-documents.component.scss'],
})
export class ClaimDocumentsComponent implements OnInit {
  exposures: any = [];
  claimid: string;
  documents: any = [];
  claim: any = {};
  blob: Blob;
  isAcmic = false;
  docActionClass: string;
  constructor(
    private activeRoute: ActivatedRoute,
    private documentsDataService: DocumentsDataService,
    private policyDetailsService: PolicyDetailsService,
    private claimsService: ClaimsService,
    private claimsDataService: ClaimsDataService,
    private acmicService: AcmicService,
    private elementRef: ElementRef,
    private urlValidationService: UrlValidationService
  ) { }

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.activeRoute.params.subscribe((params: Params) => {
      this.claimid = params['claimid'];
    });
    this.claimsDataService.$claimsLossDetails.subscribe((claimsList) => {
      if (claimsList) {
        claimsList.forEach((claim) => {
          if (claim.number.number === this.claimid) {
            this.claim = claim;
          }
        });
      }
    });
    this.claimsService
      .getClaimDocuments(this.claimid, this.claim.policyNumber.policyNumber)
      .subscribe((documents) => {
        this.documents = documents;
      });
    this.documentsDataService.getCustomLoader().subscribe(indexToHideLoader => {
      if (indexToHideLoader !== '') {
        this.documentsDataService.removeCustomLoaderClass(indexToHideLoader, this.elementRef, this.docActionClass);
        this.docActionClass = '';
      }
    });
  }

  onDownloadDocument(
    policyNumber: string,
    documentId: string,
    policyId: string,
    documentType: string,
    date: string,
    index
  ) {
    this.docActionClass = 'download-doc-action';
    this.documentsDataService.addCustomLoaderClass(index, this.elementRef, this.docActionClass)

    this.documentsDataService.getClaimDocumentData(policyNumber, policyId,
      documentId,
      `${documentType}_${policyId}_${date}`,
      true,
      index
    );
  }

  viewDocUsingByteArray(blob, windowRef) {
    const url: any = window.URL.createObjectURL(blob);
    if (this.urlValidationService.isApprovedRedirectUrl(url)) {
      if (this.documentsDataService.isItIosDevice()) {
        if (!this.documentsDataService.handlePopupBlocker(windowRef)) {
          windowRef.location = url;
        }
      } else {
        const windowNonIos = window.open(url, '_blank');
        this.documentsDataService.handlePopupBlocker(windowNonIos);
      }
    }
  }

  onSuccessResponseForPresigned(response, windowRef, indexToHideLoader) {
    this.documentsDataService.setCustomLoaderFlag(indexToHideLoader);
    if (response) {
      if (this.urlValidationService.isApprovedRedirectUrl(response?.presignedUrl)) {
        if (this.documentsDataService.isItIosDevice()) {
          if (!this.documentsDataService.handlePopupBlocker(windowRef)) {
            windowRef.location = response?.presignedUrl;
          }
        } else {
          const windowNonIos = window.open(response?.presignedUrl, '_blank');
          this.documentsDataService.handlePopupBlocker(windowNonIos);
        }
      }
    }
  }

  viewDocumentWhenNotItsNativePlatform(policyNumber, documentId, policyId, index) {
    let windowRef;
    if (this.documentsDataService.isItIosDevice()) {
      windowRef = window.open();
    }
    this.policyDetailsService
      .getDocumentByIdForClaim(policyNumber, policyId, documentId)
      .subscribe((response) => {
        this.onSuccessResponseForPresigned(response, windowRef, index);
      });
  }
  onViewDocument(
    policyNumber: string,
    documentId: string,
    policyId: string,
    documentType: string,
    date: string,
    index
  ) {
    this.docActionClass = 'view-doc-action';
    this.documentsDataService.addCustomLoaderClass(index, this.elementRef, this.docActionClass);

    if (Capacitor.isNativePlatform()) {
      this.documentsDataService.getClaimDocumentData(policyNumber, policyId,
        documentId,
        `${documentType}_${policyId}_${date}`,
        false
      );
    } else {
      this.viewDocumentWhenNotItsNativePlatform(policyNumber, documentId, policyId, index);
    }
  }
}
